import { GetterTree } from 'vuex';
import { StartpageModule } from './types';
import { RootModule } from '../root-module';
import { crmapi } from '@/types/crm-types';

export const getters: GetterTree<StartpageModule, RootModule> = {

  projects(state): crmapi.Project[] {
    return state.projects;
  },
  searchstring(state): string {
    return state.searchstring;
  },
};
